import React from 'react'
import EmbedNode from '../EmbedNode'

export default function YoutubeNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='youtube.com' transformUrl={url => url.replace('/watch?v=','/embed/')} className='aspect-video' text='Youtube Link' id={id} data={data} selected={selected} {...props} />
    )
}
